import { Link, useLocation } from 'react-router-dom';

function UpdateProgressBar({ currentStep, recordId, sheetId }) {
  const location = useLocation();

  const steps = [
    { number: 1, label: 'Basic', path: '/update/basic' },
    { number: 2, label: 'Contact', path: '/update/contact' },
    { number: 3, label: 'Personal', path: '/update/personal' },
    { number: 4, label: 'Housing', path: '/update/housing' },
    { number: 5, label: 'Disability', path: '/update/disability' },
    { number: 6, label: 'Education', path: '/update/education' },
    { number: 7, label: 'Vocational', path: '/update/vocational' },
    { number: 8, label: 'Economic', path: '/update/economic' },
    { number: 9, label: 'Assistance', path: '/update/assistance' },
    { number: 10, label: 'Home', path: '/update/home' },
    { number: 11, label: 'Welfare', path: '/update/welfare' },
    { number: 12, label: 'Rehabilitation', path: '/update/rehabilitation' },
  ];

  const getStepClass = (stepNumber) => {
    if (stepNumber === currentStep) return 'active';
    if (stepNumber < currentStep) return 'completed';
    return '';
  };

  return (
    <div className="progress-indicator mb-4">
      {steps.map((step) => (
        <Link
          key={step.number}
          to={`${step.path}/${recordId}?sheetId=${sheetId}`}
          className={`progress-step ${getStepClass(step.number)}`}
        >
          <span className="step-number">{step.number}</span>
          <span className="step-label">{step.label}</span>
        </Link>
      ))}
    </div>
  );
}

export default UpdateProgressBar;
